import React from 'react';
import { Link } from 'react-router-dom';
import { EmptyNotifications } from '../EmptyNotifications';
import { NotificationAlertItem } from '../NotificationAlertItem';
import { ALERT_NOTIFICATION, generateRoutePath } from '@fullstory/routes';
import { segmentIdFromKey, alertSexpr } from '../../utils';

import css from '../../styles/alerts/alertsOverlay.module.scss';
import { SegmentsById } from '@fullstory/redux';
import { AlertNotificationsResponse } from '@fullstory/client-api';

export const NotificationsList: React.FC<{
  segments: SegmentsById;
  orgId: string;
  onCloseSignal: () => void;
  notifications: AlertNotificationsResponse | null;
}> = ({ notifications, orgId, segments, onCloseSignal }) => (
  <div data-component="NotificationsList">
    {(notifications?.Notifications?.length ?? 0) === 0 ? (
      <EmptyNotifications />
    ) : (
      <div>
        {notifications?.Notifications?.map(notification => {
          const segmentId = segmentIdFromKey(notification.Key);
          const segment = segments[segmentId];
          if (segment == null) return null;
          return (
            <Link
              className={css.noUnderline}
              to={generateRoutePath(ALERT_NOTIFICATION, {
                orgId,
                segmentId,
                alertId: notification.Key.AlertId,
                search: alertSexpr(notification.Notification.Alert),
                notificationId: notification.Key.AlertNotificationId,
              })}
              key={notification.Key.AlertNotificationId}
            >
              <NotificationAlertItem
                notification={notification}
                segment={segment}
                onClick={onCloseSignal}
              />
            </Link>
          );
        })}
      </div>
    )}
  </div>
);
